// [sc-49297] Apre un PDF di preventivo, ordine o DDT con la sessione
// dell'utente: l'API lo restituisce solo con il login, quindi il PDF arriva come
// blob e si apre con un URL blob: temporaneo, che non funziona fuori da questa
// sessione.

import axiosInstance from "@/axiosInstance";

// Dopo questo tempo l'URL blob: non si apre più (la scheda già aperta resta)
const BLOB_URL_TTL_MS = 60 * 1000;
const openUrls = new Set();

const revoke = (url) => {
  URL.revokeObjectURL(url);
  openUrls.delete(url);
};

// Al logout: nessun URL blob: dei documenti resta apribile
export function revokeDocumentUrls() {
  openUrls.forEach(revoke);
}

// Nome dell'oggetto da un URL salvato (.../api/upload/documents/<nome>)
export function nomeDaUrl(url) {
  if (!url) return null;
  return String(url).split(/[?#]/)[0].split("/").pop() || null;
}

export async function openDocument(objectName) {
  // La scheda va aperta subito, nel click: dopo l'await il browser la bloccherebbe
  const win = window.open("", "_blank");
  try {
    const { data } = await axiosInstance.get(
      `/upload/documents/${encodeURIComponent(objectName)}`,
      { responseType: "blob" }
    );
    // Tipo forzato: l'URL blob: ha l'origine del CRM, quindi un file che non è
    // un PDF (es. HTML) non deve mai essere mostrato col suo tipo
    const url = URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );
    openUrls.add(url);
    setTimeout(() => revoke(url), BLOB_URL_TTL_MS);
    if (win) win.location.href = url;
    else window.location.href = url;
  } catch (err) {
    if (win) win.close();
    throw err;
  }
}
